import { Surface, Symbols } from "recharts";

function CustomizedLegend({
  payload = [],
  disabled = {},
  textColor,
  onItemClick,
}) {
  return (
    <div className="tw:flex tw:max-h-[30%] tw:flex-wrap tw:justify-center tw:gap-x-3 tw:gap-y-1 tw:overflow-y-auto tw:px-2 tw:py-1">
      {payload.map(entry => {
        const { dataKey, color } = entry;
        const hidden = !!disabled[dataKey];
        return (
          <span
            key={dataKey}
            className="tw:inline-flex tw:cursor-pointer tw:items-center tw:gap-1"
            style={{ color: hidden ? "#AAA" : textColor }}
            onClick={() => onItemClick(dataKey)}
          >
            <Surface
              width={10}
              height={10}
              viewBox={{ x: 0, y: 0, width: 10, height: 10 }}
            >
              <Symbols cx={5} cy={5} type="circle" size={50} fill={color} />
              {hidden && (
                <Symbols cx={5} cy={5} type="circle" size={25} fill="#FFF" />
              )}
            </Surface>
            <span>{dataKey}</span>
          </span>
        );
      })}
    </div>
  );
}

export default CustomizedLegend;
